import { useApp } from '@/core/state/appStore'
import {
  ShellFormularBox,
  type ShellFormularApi,
  type ShellFormularTexte,
} from '@/core/components/form/ShellFormularBox'
import { Button, Icon } from 'admination-react'
import {
  getAufnahmePotenzialanalyse,
  fetchAufnahmePotenzialanalyseVorschau,
  saveAufnahmePotenzialanalyse,
  speichereEntwurf,
  aufnahmePotenzialanalyseProbleme,
  aufnahmePotenzialanalyseHinweise,
} from '../../api/aufnahmePotenzialanalyse'

const API_ABGESCHLOSSEN: ShellFormularApi = {
  laden: (coachingId) => getAufnahmePotenzialanalyse(coachingId),
  vorschau: (coachingId, werte) => fetchAufnahmePotenzialanalyseVorschau(coachingId, werte),
  speichern: (coachingId, werte, bestaetigt) => saveAufnahmePotenzialanalyse(coachingId, werte, bestaetigt),
  probleme: (error) => aufnahmePotenzialanalyseProbleme(error),
  hinweise: (error) => aufnahmePotenzialanalyseHinweise(error),
}

const API: ShellFormularApi = {
  ...API_ABGESCHLOSSEN,
  entwurfSpeichern: (coachingId, werte) => speichereEntwurf(coachingId, werte),
}

const DOKUMENT = 'Aufnahme- und Potenzialanalyse'

const TEXTE: ShellFormularTexte = {
  name: 'Aufnahme- und Potenzialanalyse',
  gespeichert: 'Aufnahme- und Potenzialanalyse gespeichert',
  ladenFehlgeschlagen: 'Die Aufnahme- und Potenzialanalyse konnte nicht geladen werden.',
  speichernFehlgeschlagen: 'Die Aufnahme- und Potenzialanalyse konnte nicht gespeichert werden.',
}

export function AufnahmePotenzialanalyse({ coachingId }: { coachingId: string | null }) {
  const { dispatch, coachings } = useApp()
  const abgeschlossen = coachings.find((c) => c.id === coachingId)?.documents.includes(DOKUMENT) ?? false

  function openTeilnehmerakte() {
    if (!coachingId) return
    const name = coachings.find((c) => c.id === coachingId)?.name ?? ''
    dispatch({ type: 'OPEN_PARTICIPANT', screen: {
      kind: 'akte',
      participant: { id: coachingId, name },
      source: { kind: 'bar' },
    } })
  }

  return (
    <ShellFormularBox
      coachingId={coachingId}
      api={abgeschlossen ? API_ABGESCHLOSSEN : API}
      texte={TEXTE}
      kopfAktionen={({ saving }) => (
        <div className="pill">
          <Button
            iconOnly
            title="Teilnehmerakte"
            disabled={saving || !coachingId}
            onClick={openTeilnehmerakte}
          >
            <Icon name="i-signature" />
          </Button>
        </div>
      )}
    />
  )
}
